import { ContractorAction } from "../actions/contractor";
import { ContractorDetails, ContractorUserDetails } from "../models";

export interface ContractorState {
  loading: boolean;
  contractors: ContractorDetails[];
  contractor: ContractorDetails | null;
  contractorUserDetails: ContractorUserDetails | null;
  totalRecords: number;
}

const defaultState: ContractorState = {
  loading: false,
  contractors: [],
  contractor: null,
  contractorUserDetails: null,
  totalRecords: 0,
};

const ContractorReducer = (
  state = defaultState,
  action: any
): ContractorState => {
  switch (action.type) {
    case ContractorAction.REQUEST_GET_CONTRACTORS:
      return {
        ...state,
        loading: true,
        contractors: [],
      };
    case `${ContractorAction.REQUEST_GET_CONTRACTORS}_SUCCESS`:
      return {
        ...state,
        loading: false,
        contractors: action.payload.contractors,
        totalRecords: action.payload.total,
      };
    case `${ContractorAction.REQUEST_GET_CONTRACTORS}_FAILURE`:
      return {
        ...state,
        loading: false,
        contractors: [],
      };
    case ContractorAction.REQUEST_GET_CONTRACTOR_DETAILS:
      return {
        ...state,
        loading: true,
        contractor: null,
      };
    case `${ContractorAction.REQUEST_GET_CONTRACTOR_DETAILS}_SUCCESS`:
      return {
        ...state,
        loading: false,
        contractor: action.payload,
      };
    case `${ContractorAction.REQUEST_GET_CONTRACTOR_DETAILS}_FAILURE`:
      return {
        ...state,
        loading: false,
        contractor: null,
      };
    case ContractorAction.REQUEST_GET_CONTRACTOR_USER_DETAILS:
      return {
        ...state,
        loading: true,
        contractorUserDetails: null,
      };
    case `${ContractorAction.REQUEST_GET_CONTRACTOR_USER_DETAILS}_SUCCESS`:
      return {
        ...state,
        loading: false,
        contractorUserDetails: action.payload,
      };
    case `${ContractorAction.REQUEST_GET_CONTRACTOR_USER_DETAILS}_FAILURE`:
      return {
        ...state,
        loading: false,
        contractorUserDetails: null,
      };

    default:
      return state;
  }
};

export default ContractorReducer;
